import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Wordmark from "../components/Wordmark";

const BG = "https://images.unsplash.com/photo-1599060052009-24d6d0b0161c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    const res = await register(email, password, name, inviteCode.trim());
    setLoading(false);
    if (res.ok) navigate("/onboarding");
    else setError(res.error);
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[var(--auth-overlay)]" />
      <div className="relative z-10 w-full max-w-md fade-up">
        <Link to="/login" className="mb-8 flex justify-center" data-testid="auth-brand">
          <Wordmark sizeClass="text-4xl" />
        </Link>
        <form onSubmit={submit} className="rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-surface)]/95 p-8 shadow-xl backdrop-blur-xl" data-testid="register-form">
          <h1 className="font-head text-3xl tracking-wide text-[var(--text-primary)]">Create Account</h1>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">Browse every subscription you own, beautifully.</p>

          {error && <div className="mt-4 rounded-md border border-[var(--border-accent)] bg-[var(--accent)]/10 px-3 py-2 text-sm text-[var(--accent-hover)]" data-testid="register-error">{error}</div>}

          <label className="mt-5 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)}
            className="mt-1 w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-3 text-[var(--text-primary)] outline-none focus:border-[var(--accent)]"
            data-testid="register-name-input" placeholder="Your name" />

          <label className="mt-4 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="mt-1 w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-3 text-[var(--text-primary)] outline-none focus:border-[var(--accent)]"
            data-testid="register-email-input" placeholder="you@example.com" />

          <label className="mt-4 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="mt-1 w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-3 text-[var(--text-primary)] outline-none focus:border-[var(--accent)]"
            data-testid="register-password-input" placeholder="At least 6 characters" />

          <label className="mt-4 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Invite code <span className="text-[var(--text-muted)]">(optional)</span></label>
          <input value={inviteCode} onChange={(e) => setInviteCode(e.target.value)}
            className="mt-1 w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-3 uppercase tracking-wider text-[var(--text-primary)] outline-none focus:border-[var(--accent)]"
            data-testid="register-invite-input" placeholder="Unlocks Full Access" />

          <button type="submit" disabled={loading}
            className="mt-6 w-full rounded-[var(--card-radius)] bg-[var(--accent)] py-3 font-bold uppercase tracking-wide text-[var(--accent-contrast)] transition-colors hover:bg-[var(--accent-hover)] disabled:opacity-60"
            data-testid="register-submit-button">
            {loading ? "Creating..." : "Create Account"}
          </button>

          <p className="mt-5 text-center text-sm text-[var(--text-secondary)]">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-[var(--text-primary)] hover:underline" data-testid="go-login-link">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
